import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const PROJECT_TASKS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('PROJECT_TASKS');
export const PROJECT_TASKS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	PROJECT_TASKS_CRUD_ACTION_CONSTANTS
);
